import React from 'react';
import { handleStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  // useMediaQuery,
  // queryHelpers,
} from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { SHARED_LIBRARY_ASSET_KEYS } from '../../types/shared-library.types';

export function NavigateBack() {
  // const is355 = useMediaQuery(queryHelpers.between([300, 359]));
  const navigate = useNavigate();

  const navigateBack = () => {
    navigate(-1);
  };

  return (
    <Box
      css={
        {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          position: 'relative',
          marginBottom: '$quarter',
          height: '40px',
          width: '85%',
          top: '15px',
          opacity: 1,
          '@mobile': {
            width: '100%',
            background: 'white',
            top: '0',
            marginBottom: '0',
            height: '50px',
          },
          '@tablet': { width: '90%' },
        } as GDSStyleObject
      }
    >
      <input
        type="image"
        src={handleStaticAsset(SHARED_LIBRARY_ASSET_KEYS.CROSS_ICON) as string}
        alt="close the online form"
        onClick={navigateBack}
      />
    </Box>
  );
}
